export const adsMenuItems = [
  {
    key: '9',
    path: '/AdSchedule',
    icon: 'control',
    label: '廣告排程'
  },
  {
    key: '10',
    path: '/AdResources',
    icon: 'control',
    label: '廣告資源管理'
  },
  {
    key: '11',
    path: '/AdCampaignList',
    icon: 'control',
    label: '廣告投放排程列表'
  },
  {
    key: '12',
    path: '/AdTrackingReport',
    icon: 'control',
    label: '廣告紀錄表'
  }
]

export const adsRoutePaths = adsMenuItems.map(item => item.path)
